"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddFeatureFlagListInitializer = exports.FeatureFlagInitializer = exports.FeatureFlagInitializationError = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const featureFlag_1 = require("./featureFlag");
const FEATURE_FLAG_ERROR = 'Feature flags initialization error';
class FeatureFlagInitializationError extends web_ui_framework_1.InitializerError {
    constructor(message) {
        super(FEATURE_FLAG_ERROR, message);
    }
}
exports.FeatureFlagInitializationError = FeatureFlagInitializationError;
class FeatureFlagInitializer extends web_ui_framework_1.Initializer {
    constructor(config, api) {
        super([api]);
        this.launch = async () => {
            try {
                if (!this.config.notLoadOnRoutes?.includes(location?.pathname)) {
                    await (0, featureFlag_1.initFeatureFlag)(this.config, this.api.getInitialized());
                }
            }
            catch (e) {
                throw new FeatureFlagInitializationError(e);
            }
        };
        this.config = config;
        this.api = api;
    }
}
exports.FeatureFlagInitializer = FeatureFlagInitializer;
class AddFeatureFlagListInitializer extends web_ui_framework_1.Initializer {
    constructor(flags) {
        super();
        this.launch = () => {
            try {
                (0, featureFlag_1.setFeatureFlag)(this.flags);
            }
            catch (e) {
                throw new FeatureFlagInitializationError(e);
            }
        };
        this.flags = flags;
    }
}
exports.AddFeatureFlagListInitializer = AddFeatureFlagListInitializer;
//# sourceMappingURL=featureFlag.initializer.js.map